import { AuthService } from "./../../auth/auth.service";
import { Injectable } from "@angular/core";
import {
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class RegistrationGuardService implements CanActivateChild {
  constructor(private router: Router, private auth: AuthService) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (route.url.length == 0) return true;

    if (route.url[0].path === "org") {
      if (localStorage.getItem("currentUser")) {
        // let userID = JSON.parse(localStorage.getItem("currentUser")).id;
        let userID;
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));

        if (currentUser.user) {
          userID = currentUser.user.id;
        } else {
          userID = currentUser.id;
        }

        if (userID) {
          return true;
        }
      }

      this.router.navigateByUrl("/reg/register");
      return false;
    } else if (route.url[0].path === "plans") {
      if (localStorage.getItem("organization")) {
        let userID;
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));

        if (currentUser.user) {
          userID = currentUser.user.id;
        } else {
          userID = currentUser.id;
        }

        let organizationID = JSON.parse(localStorage.getItem("organization"))
          .id;

        if (organizationID) {
          return true;
        }
      }

      // return true;

      this.router.navigateByUrl("/reg/org");
      return false;
    }

    return true;
  }
}
